<template>
  <div class="the-input">
    <el-popover class="input" placement="top-start" trigger="manual" v-model="inputPopoverShow"
                content="请输入想要查询的内容">
      <input type="text" id="submit-input" @keydown.enter="submitInput" v-model="inputMessage" slot="reference"
             :placeholder="inputTips"/>
    </el-popover>

    <div class="options">
<!--      <div class="img-wrap" >-->
<!--        <img src="@/assets/img/pic.png"/>-->
<!--      </div>-->
      <div class="img-wrap">
        <img src="@/assets/img/mico.png" @click="onStartVideoInputing"/>
      </div>
      <div class="btn-wrap">
        <button @click="submitInput">发送</button>
      </div>
    </div>
    <!-- <div class="img-wrap" @click="submitInput">
        <img src="@/assets/img/paperPlane.png" />
    </div> -->

    <div class="video-speeching-wrapper" v-show="showVideoInputing">
      <div class="video-speeching">
        <div class="video-speeching_icon">
          <img src="@/assets/img/speeching.svg">
          <div class="wave">
            <div class="circle"></div>
          </div>
        </div>
        <div class="video-speeching_label">正在语音识别中，请说...</div>
      </div>

      <div class="video-speeching-ctrl video-speeching-close" @click="onCloseVideoSpeeching">
        <i class="el-icon-close"></i>
      </div>

      <div class="video-speeching-ctrl video-speeching-conform" @click="onConfirmVideoSpeeching">
        <i class="el-icon-check" ></i>
      </div>
    </div>

  </div>
</template>

<script>
import {Popover} from "element-ui";
import {VoiceConfig} from "@config/sys.config";
import {getWebSocketUrl, renderResult, resetResultText, toBase64} from "@/assets/speech";
import {jsRecorder} from "@/assets/speech/record";
import {inputTips} from '@/config/sys.config'

const systemOption = {
  HEART_BEAT: 'HeartBeat'
}

export default {
  name: "the-input",
  mixins: [],
  props: {},
  components: {
    "el-popover": Popover,
  },
  data() {
    return {
      inputMessage: '',
      inputPopoverShow: false,
      inputPopoverTimeoutHandler: null,

      showVideoInputing: false,
      recStart: null,//开始录音
      recStop: null,//结束录音
      tempSearch: '',
      xfyunSpeechWebsocket: '',
      // 是否正在记录
      isRecording: false,
      // 是否录制完成
      isRecordingComplete: false,
      // 是否语音输入
      voiceFlag: true,
      // 语音定时器，如果没有主动结束录音，30S后自动结束语音输入
      voiceCleanTimer: null,

      useSpeechResult: true,
      videoInputStream: '',
      inputTips
    }
  },
  methods: {
    showInputPopover() {
      if (this.inputPopoverTimeoutHandler) {
        clearTimeout(this.inputPopoverTimeoutHandler);
      }
      this.inputPopoverTimeoutHandler = setTimeout(() => {
        this.inputPopoverShow = false;
      }, 1000);
      return (this.inputPopoverShow = true);
    },
    submitInput() {
      this.inputMessage = this.inputMessage.trim();
      if (!this.inputMessage) {
        return this.showInputPopover();
      }
      this.$emit('confirm', this.inputMessage)
      this.inputMessage = ''
    },
    onStartVideoInputing () {
      this.stopAudioPlay();
      if(VoiceConfig.useVideo === VoiceConfig.support.XunFei) {
        this.startVideo()
      }
      this.showVideoInputing = true

    },
    onCloseVideoSpeeching () {
      this.useSpeechResult = false
      this.endRecord()
      this.showVideoInputing = false
    },

    onConfirmVideoSpeeching () {
      this.useSpeechResult = true
      this.endRecord()
      this.showVideoInputing = false
    },

    // 语音输入
    initVideo () {
      // 使用 jsRecorder 创建一个对象并进行解构操作
      const callback = (blob) => {
        // console.log(encTime)
        // 发送音频ArrayBuffer
        if (this.xfyunSpeechWebsocket && this.xfyunSpeechWebsocket.readyState == 1 && this.isRecording) {
          // 创建一个FileReader实例
          const reader = new FileReader();
          // 定义onload事件处理器
          reader.onload = function (e) {
            // 这里的e.target.result就是一个ArrayBuffer
            const arrayBuffer = e.target.result;
            // 发送ArrayBuffer
            this.xfyunSpeechWebsocket.send(JSON.stringify({
              data: {
                status: 1,
                format: "audio/L16;rate=16000",
                encoding: "raw",
                audio: toBase64(new Uint8Array(arrayBuffer)),
              },
            }));
          }.bind(this); // 使用bind确保this指向正确
          // 使用FileReader的readAsArrayBuffer方法读取Blob
          reader.readAsArrayBuffer(blob);
        }
      };
      const recorder = jsRecorder(callback)
      // 开始录音、结束录音方法
      this.recStart = recorder.recStart
      this.recStop = recorder.recStop
    },

    closeRecord () {
      // 关闭录音功能
      clearTimeout(this.voiceCleanTimer);

    },

    startVideo () {
      this.show = false

      this.startSpeechRecognition()
      clearTimeout(this.voiceCleanTimer);
      this.voiceCleanTimer = setTimeout(() => {
        // 50S后停止录音
        this.stopAudioPlay();
        this.closeWebsocket()
      }, 50000)
    },

    // 结束录音
    endRecord() {
      console.log('结束语音录入')
      clearTimeout(this.voiceCleanTimer);
      this.stopRecording()
    },

    stopRecording() {
      if (!this.isRecording) return;
      this.isRecording = false;
      this.isRecordingComplete = false; // 重置标志
      if (VoiceConfig.useVideo === VoiceConfig.support.XunFei) {
        this.closeWebsocket()
      } else {
        //this.mediaRecorder.stop(); // 停止录制
        //console.log('stopRecording time=', new Date().toString())
        //this.closeMicrophone();
      }

      this.videoInputStream.getTracks().forEach(track => {
        track.stop();
      });
    },

    closeWebsocket() {
      //console.log("关闭socket连接")
      //关闭录音
      this.recStop();
      // websocket关闭参数
      if (this.xfyunSpeechWebsocket && this.xfyunSpeechWebsocket.readyState == 1) {
        this.xfyunSpeechWebsocket.send(
          JSON.stringify({
            data: {
              status: 2,
              format: "audio/L16;rate=16000",
              encoding: "raw",
              audio: '',
            },
          })
        )
      }
    },

    startSpeechRecognition () {
      this.tempSearch = ''
      resetResultText()
      // 判断麦克风是否打开
      navigator.mediaDevices.getUserMedia({audio: true}).then(stream => {
        this.videoInputStream = stream
        //调用websocket方法
        // 如果需要加一些图片验证或者其他验证在这里加一些逻辑，成功之后调用websocket
        this.isRecording = true
        // 调用录音方法
        this.recStart()
        this.asrWebSocket()
      }).catch(error => {
        console.error(error)
        this.$message.error('麦克风未打开！');
        // 麦克风未打开
        switch (error.message || error.name) {
          case 'PERMISSION_DENIED':
          case 'PermissionDeniedError':
            console.info('用户拒绝提供信息。')
            break
          case 'NOT_SUPPORTED_ERROR':
          case 'NotSupportedError':
            console.info('浏览器不支持硬件设备。')
            break
          case 'MANDATORY_UNSATISFIED_ERROR':
          case 'MandatoryUnsatisfiedError':
            console.info('无法发现指定的硬件设备。')
            break
          default:
            console.info('无法打开麦克风。异常信息:' + (error.code || error.name))
            break
        }
      });
    },

    // 语音输入socket
    asrWebSocket() {
      //使用后端提供的地址
      let websocketUrl = getWebSocketUrl()
      //new 一个websocket
      this.xfyunSpeechWebsocket = new WebSocket(websocketUrl)
      //console.log(this.xfyunSpeechWebsocket,'new websocket')
      this.xfyunSpeechWebsocket.onopen = () => {
        //console.log('连接成功')
        //链接成功之后发送websocket请求参数
        this.sendStart()
      }
      // 客户端接收服务端返回的数据
      this.xfyunSpeechWebsocket.onmessage = (evt) => {
        let data = JSON.parse(evt.data)
        if (data.code == 0 && data.data.status === 1) {
          this.tempSearch = renderResult(evt.data)
        }
        console.log("语音识别结果：", this.tempSearch)
        this.inputMessage = (this.tempSearch + '').trim()
        if (data.data.status === 2 && this.useSpeechResult) {
          // 用语音文本进行提问
          this.inputMessage = this.tempSearch;
          this.submitInput()
        }
      }
      this.xfyunSpeechWebsocket.onerror = (evt) => {
        console.error('websocket-asr错误：', evt)
      }
      // 关闭连接
      this.xfyunSpeechWebsocket.onclose = (evt) => {
        console.log('websocket-asr关闭：', evt)
      }
    },

    sendStart() {
      var params = {
        common: {
          app_id: VoiceConfig.XunFeiConfig.appId,
        },
        business: {
          language: "zh_cn",
          domain: "iat",
          accent: "mandarin",
          vad_eos: 5000,
          dwa: "wpgs",
        },
        data: {
          status: 0,
          format: "audio/L16;rate=16000",
          encoding: "raw",
        },
      };
      this.xfyunSpeechWebsocket.send(JSON.stringify(params))
    },

    // 停止语音播放
    stopAudioPlay() {
      this.closeWs()
      this.playAudioEndIndex = 0
      this.playAudioFlag = false
      if (this.player != null) {
        this.player.destroy();
        this.player = null
      }
    },

    // 关闭语音合成ws
    closeWs() {
      if (this.ttsSession !== undefined && this.ttsSession !== null && this.ttsSession !== '') {
        let params = {
          task: 'tts',
          signal: 'end',
          session: this.ttsSession
        };
        this.ttsWebsocket.send(JSON.stringify(params))
        this.ttsSession = ''
      }
      this.ttsWsCleanHeart()
      this.ttsRealClose = true
      if (this.ttsWebsocket && this.ttsWebsocket.readyState === 1) {
        this.ttsWebsocket.close()
      }
      if (this.player !== undefined && this.player !== null) {
        this.player.destroy()
        this.player = null
      }
    },

    // 语音合成重连
    ttsWsReconnect() {
      const that = this;
      if (that.ttsWsReconnectLock) {
        return;
      }
      that.ttsWsReconnectLock = true;
      that.ttsWsReconnectTimer && clearTimeout(that.ttsWsReconnectTimer);
      that.ttsWsReconnectTimer = setTimeout(() => {
        //console.log("ttsWsReconnect WebSocket: 重连中...");
        that.ttsWsReconnectLock = false;
        // websocket启动
        that.initWebSocket();
      }, 4000);
    },
    // 语音合成清除心跳检测机制
    ttsWsCleanHeart() {
      const that = this;
      clearTimeout(that.ttsWsTimeoutObj);
      clearTimeout(that.ttsWsServerTimeoutObj);
    },
    // 语音合成心跳检测启动
    ttsWsStartHeart() {
      const that = this;
      clearTimeout(that.ttsWsTimeoutObj);
      clearTimeout(that.ttsWsServerTimeoutObj);

      that.ttsWsTimeoutObj && clearTimeout(that.ttsWsTimeoutObj);
      that.ttsWsServerTimeoutObj && clearTimeout(that.ttsWsServerTimeoutObj);

      that.ttsWsTimeoutObj = setTimeout(() => {
        // 这里向后端发送一个心跳检测，后端收到后，会返回一个心跳回复
        that.ttsWebsocket.send(systemOption.HEART_BEAT);
        //console.log("ttsWsStartHeart WebSocket: 发送心跳检测");

        that.ttsWsServerTimeoutObj = setTimeout(() => {
          // 如果超过一定时间还没重置计时器，说明websocket与后端断开了
          that.ttsWebsocket.close();
          //console.log("ttsWsStartHeart WebSocket: 未收到心跳检测回复");
        }, that.ttsHeartTimerTimeout);
      }, that.ttsHeartTimerTimeout);
    },


  },
  mounted() {
    this.initVideo()
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/css/_var.scss';

.the-input {
  height: $inputHeight;
  padding: 10px;
  background: #fff;
  width: 90%;
  border-radius: 10px;
  position: relative;
  .input {
    width: 100%;
    position: relative;
  }

  input {
    display: block;
    width: 100%;
    border: none;
    outline: none;
    font-size: $chatFontSize;
    padding: 10px 10px 0;

    &:focus {
      transition: 0.2s ease-in-out;
    }
  }

  .options {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-top: 10px;
    margin-bottom: 10px;
  }

  .img-wrap {
    font-size: $chatFontSize;
    width: 4.5rem;
    height: 2.3rem;
    padding: 0 12px;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    transition: 0.2s ease-in-out;
    justify-content: center;
    user-select: none;
    transform: scale(1);
    transition: .2s ease-in-out;

    &:hover {
      transition: .2s ease-in-out;
      transform: scale(1.1);
    }

  }

  .btn-wrap {
    button {
      font-size: $chatFontSize;
      width: 5rem;
      height: 2.3rem;
      border-radius: 4px;
      background: rgba(38, 111, 235, 1);
      display: flex;
      justify-content: center;
      align-items: center;
      color: #fff;
      border: none;
      cursor: pointer;
      transition: .2s ease-in-out;

      &:hover {
        background: rgba(38, 111, 235, .8);
      }
    }
  }

  .video-speeching-wrapper {
    position: absolute;
    left: 0;
    bottom: 0;
    padding: 0;
    width: 100%;
    height: 41px;
    background: #fff;
    border-radius: 0 10px 10px 0;
    display: flex;

    .video-speeching-ctrl {
      width: 30px;
      height: 30px;
      border-radius: 52px;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      i {
        font-size: 16px;
        color: #FFF;
      }
    }

    .video-speeching-close {
      background: #dd6161;
      left: 60px;
      margin-left: auto;
    }

    .video-speeching-conform {
      background: #13ce66;
      right: 60px;
      margin-left: 10px;
      margin-right: 15px;
    }

    .video-speeching {
      display: flex;
      position: relative;
      margin-left: 15px;
      text-align: center;
      .video-speeching_icon {
        display: inline-block;
        position: relative;
        margin-top: 0;
      }
      img {
        width: 36px;
        height: 36px;
        position: relative;
        z-index: 2;
      }

      .video-speeching_label {
        text-align: center;
        color: #658cf6;
        margin-top: 8px;
        margin-left: 10px;
      }

      /* 波动效果 */
      .wave {
        position: absolute;
        width: 36px;
        height: 36px;
        text-align: center;
        z-index: 1;
        top: 0%;
        left: 0%;
      }

      .wave .circle {
        width: 100%;
        height: 100%;
        position: absolute;
        border-radius: 50%;
        opacity: 0;
        background: rgba(119, 172, 248, 0.8);
      }

      .wave .circle:first-child {
        animation: circle-opacity 1s infinite;
      }
    }

    & img:nth-child(3) {
      width: 32px;
      height: 32px;
    }
  }

}


@keyframes circle-opacity {
  from {
    opacity: 1;
    transform: scale(1);
  }
  to {
    opacity: 0;
    transform: scale(1.15);
  }
}

</style>
